import { Printer, Clock, AlertCircle } from 'lucide-react';

/**
 * Get display status based on job queue state
 */
export const getStatusDisplay = (jobQueue, currentJob) => {
  if (jobQueue.length === 0) {
    return {
      icon: <Clock className="w-24 h-24 text-muted-foreground" />,
      title: 'Ready to Print',
      description: 'Scan the QR code with your phone to start'
    };
  }

  if (currentJob) {
    return {
      icon: <Printer className="w-24 h-24 text-accent animate-pulse" />,
      title: 'Print Job Ready',
      description: 'Enter your OTP to start printing'
    };
  }

  return {
    icon: <AlertCircle className="w-24 h-24 text-yellow-500" />,
    title: 'Processing',
    description: 'Please wait...'
  };
};
